import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ArmService } from '@kv-common-components/kx-services';
import { I18nPipe } from '@shared/pipes/i18n.pipe';
import { NGXLogger } from 'ngx-logger';
import { FormatHelperService } from './format-helper.service';
import { RouteEnum } from './route-enum';

@Injectable({
    providedIn: 'root',
})
export class AppointmentHelperService {
    presAppointmentModalContent =
        'appointment.appointment-type.modal.phone.confirmation.pres';
    postAppointmentModalContent =
        'appointment.appointment-type.modal.phone.confirmation.post';
    showAppointmentConfirmModal = false;
    appointmentToConfirm: any;
    appointmentCenter: any; // center fo which the user wants to get an appointment
    textModalRdv: string;
    buttonRight: string;
    specificIconBlock: string;
    titleModalRdv: string;
    appointmentConfirmModalContent: any;
    centerToCallBack: any;
    showModalCallbackCenter = false;

    constructor(
        private armService: ArmService,
        private router: Router,
        private logger: NGXLogger,
        private i18nPipe: I18nPipe
    ) {}

    getAppointmentsSortedByDate(center: any): any[] {
        const sortedAppointmentsByDate = [];
        center.rendezVous.forEach((appointment) => {
            const date = {
                dayName: FormatHelperService.getDateFormatted(
                    appointment.dateDebut,
                    'dddd'
                ),
                dayNumber: FormatHelperService.getDateFormatted(
                    appointment.dateDebut,
                    'D'
                ),
                monthName: FormatHelperService.getDateFormatted(
                    appointment.dateDebut,
                    'MMM'
                ),
                year: FormatHelperService.getDateFormatted(
                    appointment.dateDebut,
                    'YYYY'
                ),
            };
            const sortedAppointmentIndex = sortedAppointmentsByDate.findIndex(
                (element) =>
                    element.date.dayName === date.dayName &&
                    element.date.dayNumber === date.dayNumber &&
                    element.date.monthName === date.monthName &&
                    element.date.year === date.year
            );
            if (sortedAppointmentIndex === -1) {
                sortedAppointmentsByDate.push({
                    date,
                    appointments: [appointment],
                });
            } else {
                sortedAppointmentsByDate[
                    sortedAppointmentIndex
                ].appointments.push(appointment);
            }
        });
        return sortedAppointmentsByDate;
    }

    postAppointment(
        idDossierMedical: string,
        listeRendezVousMedical: any[]
    ): void {
        if (listeRendezVousMedical.length === 0) {
            // si aucun rendez vous existe alors post nouveau rendez vous
            this.postNewAppointment(idDossierMedical);
        } else {
            // si rendez vous existe deja alors on supprime et on post nouveau rendez vous
            this.armService
                .deleteRendezVousMedical(
                    idDossierMedical,
                    listeRendezVousMedical[0]
                )
                .subscribe(() => {
                    this.postNewAppointment(idDossierMedical);
                });
        }
    }

    postNewAppointment(idDossierMedical: string) {
        this.armService
            .postRendezVousMedical(idDossierMedical, this.appointmentToConfirm)
            .subscribe(() => {
                this.showAppointmentConfirmModal = false;
                this.router.navigateByUrl(RouteEnum.appointmentDetails);
            });
    }

    handleCallBack(center: any): void {
        this.centerToCallBack = center;
        this.showModalCallbackCenter = true;
    }

    callBackCenter(idDossierMedical: string): void {
        this.armService
            .postWebCallBack(idDossierMedical, this.centerToCallBack.idApi)
            .subscribe((data) => {
                this.logger.debug('Operation of CallBack has been saved : ', {
                    data,
                });
                this.showModalCallbackCenter = false;
                this.router.navigateByUrl(
                    'souscription/document-medicale/document-list'
                );
            });
    }

    handleAppointmentClick($event: any, listeRendezVousMedical: any[]): void {
        this.appointmentToConfirm = $event.appointment;
        this.appointmentCenter = $event.center;
        if (listeRendezVousMedical.length === 0) {
            // si pas de rendez vous existant
            this.textModalRdv =
                'appointment.appointment-details.popin.choosehour.label';
            this.buttonRight = 'global.button.confirm';
            this.specificIconBlock = '';
            this.titleModalRdv = 'global.button.confirmation';
        } else {
            // si rendez vous existe deja
            this.textModalRdv =
                'appointment.appointment-details.popin.edit.label';
            this.buttonRight = 'global.yesedit';
            this.specificIconBlock = 'modal-info-red';
            this.titleModalRdv =
                'appointment.appointment-details.popin.edit.title';
        }

        this.appointmentConfirmModalContent = this.i18nPipe.transform(
            this.textModalRdv
        );
        this.appointmentConfirmModalContent =
            this.appointmentConfirmModalContent
                .replace(
                    /%s,/gm,
                    `<span class="bold">${FormatHelperService.getDateFormattedForAppointment(
                        this.appointmentToConfirm.dateDebut,
                        ' dddd DD MMMM, à HH[h]mm'
                    )}
                    </span>`
                )
                .replace(
                    /chez %s/gm,
                    `chez <span class="bold">${this.appointmentCenter.libelleCentre}</span>`
                );
        this.showAppointmentConfirmModal = true;
    }
}
